export default [
  {
    path: '/ver/curso/:url_public',
    name: 'course-view',
    component: () => import('@/views/ver/curso/CursoDescripcion.vue'),
    meta: {
      // protectedLogin: true, //Proteger ruta en caso de que este autentificado.
      // requiresEnterprise: true
      // requiresAuth: true
    },
  },
  {
    path: '/ver/curso/play-list/:url_public',
    name: 'course-content',
    component: () => import('@/views/ver/curso/CursoContenido.vue')
  },
  {
    path: '/ver/empleo/:url_public',
    name: 'job-view',
    component: () => import('@/views/ver/Empleo.vue')
  },
  {
    path: '/ver/empresa/:url_public',
    'name': 'enterprise-view',
    component: () => import('@/views/ver/Empresa.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/_ver.js